export default __webpack_public_path__ + "static/media/pictogramBeaconRenovations40.668ae6b6.svg";